export default {}

export const connectorLocalStorageKey = "connectorId";
